module.exports = __webpack_public_path__ + "img/ea0ff134f179f6e0f8bec2bce49c547a.svg";